<!--
 * @Author: lbh
 * @Date: 2022-10-19 10:30:13
 * @LastEditors: lbh
 * @LastEditTime: 2025-02-18 15:47:56
 * @Description: file content
-->
<template>
  <div class="self-pay-loading">
    <van-overlay :show="showOverlay">
      <div class="wrapper" @click.stop>
        <div class="pay-loading">
          <!-- <van-icon
            class="close"
            name="cross"
            size="20px"
            @click="onClose"
          /> -->
          <van-loading color="var(--themeColor)" size="72px" />
          <div class="title">{{ _t("payPopup.Paying") }}</div>
          <div class="sub-title">
            {{ _t('payPopup.Submitted_please_wait_patiently') }}
          </div>
          <van-button
            class="btn"
            color="var(--themeColor)"
            block
            round
            @click="refreshPaymentResult"
            >{{ _t("payPopup.RefreshPaymentResult") }}</van-button
          >
          <van-button
            v-if="canCancel"
            class="btn"
            color="var(--themeColor)"
            block
            round
            @click="cancelOrder"
            >{{ _t("payPopup.Cancelled") }}</van-button
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
const unCancelPayType = [6, 8, 17, 18, 19, 22, 23, 25, 30, 31, 32, 39];
import {
  online_query,
  online_payment,
  online_cancel,
} from "@/js/api/order/api";
import i18n from "../../../i18n";
import logan from "@/js/util/logan";
export default {
  name: "pay-login",
  props: {
    orderId: {
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      showOverlay: false,
      //  是否點了 取消
      isCancel: false,
      canCancel: false,
      // * 輪詢只保留一個計時器與進行中的請求。
      queryTimer: null,
      querying: false,
    };
  },
  beforeDestroy() {
    // * 移除返回監聽並停止輪詢，忽略未完成請求的結果。
    this.isCancel = true;
    clearTimeout(this.queryTimer);
    document.removeEventListener("visibilitychange", this.resumeQuery);
    window.removeEventListener("pageshow", this.resumeQuery);
  },
  destroyed() {
    this.showOverlay = false;
  },
  created() {
    // * 返回 Safari 或從頁面快取恢復時補查支付結果。
    document.addEventListener("visibilitychange", this.resumeQuery);
    window.addEventListener("pageshow", this.resumeQuery);
    if (this.orderId) {
      // 查詢接口
      this.online_query_fun();
    }
  },
  methods: {
    _t(key) {
      return i18n.t(key);
    },
    // ? 返回前景時立即查詢，已有請求時沿用其結果。
    resumeQuery() {
      if (document.visibilityState === "hidden" || this.isCancel) return;
      clearTimeout(this.queryTimer);
      this.online_query_fun();
    },
    // ? 支付查詢失敗時仍保留輪詢，避免 loading 永久停留。
    online_query_fun() {
      if (this.isCancel || this.querying || !this.orderId) return;
      clearTimeout(this.queryTimer);
      this.querying = true;
      logan.log(`支付輪詢查詢: orderId: ${this.orderId}`, logan.types.default);
      // * 成功、網絡失敗及異常回應均會釋放請求鎖。
      return Promise.resolve()
        .then(() => online_query({ orderId: this.orderId }))
        .then((res) => {
          if (this.isCancel) return;
          if (res && res.success && res.data) {
            this.canCancel = !unCancelPayType.includes(res.data.payType);
            let status = res.data.status;
            if (status == 1 || status == 4 || status == 0) {
              this.showOverlay = true;
            } else if (status == 2) {
              this.onBack(2);
            }
          } else if (res && ["code.online.payment.003", "yedPay.0006"].includes(res.errCode)) {
            this.onBack(0);
          }
        })
        .catch(() => {
          // * 暫時失敗不視為未支付，避免重複發起付款。
          logan.log(`支付輪詢失敗，等待重試: orderId: ${this.orderId}`, logan.types.default);
        })
        .finally(() => {
          this.querying = false;
          if (!this.isCancel && document.visibilityState !== "hidden" && location.href.includes("/pay/")) {
            this.queryTimer = setTimeout(this.online_query_fun, 5000);
          }
        });
    },
    // ? 手動重新載入頁面以取得最新支付結果。
    refreshPaymentResult() {
      // * 由支付頁初始化流程重新查詢訂單狀態。
      window.location.reload();
    },
    cancelOrder() {
      online_cancel({
        orderId: this.orderId,
      }).then((res) => {
        if (res.success) {
          if (!res.data) {
            this.$toast(this._t('payPopup.Cancellation_failed'));
          } else {
            this.showOverlay = false;
            this.isCancel = true;
            this.onBack(1);
          }
        } else {
          if (res.errCode == "yedPay.0006" || res.errCode == "pay.0017") {
            this.showOverlay = false;
            this.isCancel = true;
            this.onBack(1);
          } else if (res.errCode == "pay.0002") {
            this.$toast(this._t("payPopup.Paid"));
            this.showOverlay = false;
            this.isCancel = true;
            this.onBack(2);
          }
        }
      });
    },
    onClose() {
      this.$emit("close");
      document.querySelector(".self-pay-loading").remove();
    },
    /**
     * * 回調
     * @param {0 未支付, 1 已取消 , 2 已支付} type
     */
    // ? 終止當前輪詢後通知支付頁。
    onBack(type) {
      this.isCancel = true;
      this.showOverlay = false;
      clearTimeout(this.queryTimer);
      this.$emit("back", type);
    },
  },
};
</script>

<style lang="less" scoped>
.self-pay-loading {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .pay-loading {
      background-color: #fff;
      border-radius: 10px;
      padding: 70px 45px 15px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .close {
        position: absolute;
        top: 15px;
        color: #999;
        right: 15px;
      }
      .title {
        font-size: 17px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        margin-top: 14px;
        color: #333333;
      }
      .sub-title {
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        margin-top: 8px;
        color: #333333;
      }
      .btn {
        margin-top: 36px;
        height: 40px;
        line-height: 40px;
        width: 230px;
        & + .btn {
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
